import { graphql } from '@eluve/graphql.tada';

export const chatSettingsFragment = graphql(`
  fragment ChatSettings on TenantUserChatSettings @_unmask {
    __typename
    tenantId
    userId
    customInstructions
    contextSources
    files
    conversationStarters
  }
`);

export const getChatSettingsQuery = graphql(
  `
    query getChatSettings($tenantId: uuid!, $userId: uuid!) {
      tenantUserChatSettingsByPk(tenantId: $tenantId, userId: $userId) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

// Upsert - creates new chat setting record if none exists
export const upsertChatSettingsMutation = graphql(
  `
    mutation UpsertChatSettings(
      $customInstructions: String
      $contextSources: [String!]
      $files: jsonb
      $conversationStarters: jsonb
    ) {
      insertTenantUserChatSettingsOne(
        object: {
          customInstructions: $customInstructions
          contextSources: $contextSources
          files: $files
          conversationStarters: $conversationStarters
        }
        onConflict: {
          constraint: tenant_user_chat_settings_pkey
          updateColumns: [
            customInstructions
            contextSources
            files
            conversationStarters
          ]
        }
      ) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

export const updateContextSourcesMutation = graphql(
  `
    mutation UpdateContextSources(
      $tenantId: uuid!
      $userId: uuid!
      $contextSources: [String!]
    ) {
      updateTenantUserChatSettingsByPk(
        pkColumns: { tenantId: $tenantId, userId: $userId }
        _set: { contextSources: $contextSources }
      ) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

export const updateChatCustomInstructionsMutation = graphql(
  `
    mutation UpdateChatCustomInstructions(
      $tenantId: uuid!
      $userId: uuid!
      $customInstructions: String
    ) {
      updateTenantUserChatSettingsByPk(
        pkColumns: { tenantId: $tenantId, userId: $userId }
        _set: { customInstructions: $customInstructions }
      ) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

export const updateConversationStartersMutation = graphql(
  `
    mutation UpdateConversationStarters(
      $tenantId: uuid!
      $userId: uuid!
      $conversationStarters: jsonb!
    ) {
      updateTenantUserChatSettingsByPk(
        pkColumns: { tenantId: $tenantId, userId: $userId }
        _set: { conversationStarters: $conversationStarters }
      ) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

export const updateFilesMutation = graphql(
  `
    mutation UpdateFiles($tenantId: uuid!, $userId: uuid!, $files: jsonb!) {
      updateTenantUserChatSettingsByPk(
        pkColumns: { tenantId: $tenantId, userId: $userId }
        _set: { files: $files }
      ) {
        ...ChatSettings
      }
    }
  `,
  [chatSettingsFragment],
);

export const deleteChatSettingsMutation = graphql(`
  mutation DeleteChatSettings($tenantId: uuid!, $userId: uuid!) {
    deleteTenantUserChatSettingsByPk(tenantId: $tenantId, userId: $userId) {
      __typename
      tenantId
      userId
    }
  }
`);

export const llmOutputPreferencesFragment = graphql(`
  fragment LlmOutputPref on TenantUserLlmOutputPreferences @_unmask {
    __typename
    id
    tenantId
    name
    format
    detailLevel
    customInstructions
  }
`);

export const getChatPreferencesQuery = graphql(
  `
    query getChatLlmPreferences($tenantId: uuid!, $userId: uuid!) {
      tenantUserLlmOutputPreferences(
        where: { tenantId: { _eq: $tenantId }, userId: { _eq: $userId } }
        orderBy: { createdAt: ASC }
      ) {
        ...LlmOutputPref
      }
    }
  `,
  [llmOutputPreferencesFragment],
);

export const insertChatPreferenceMutation = graphql(
  `
    mutation InsertChatPreference(
      $name: String
      $format: String!
      $detailLevel: String!
      $customInstructions: String
    ) {
      insertTenantUserLlmOutputPreferencesOne(
        object: {
          name: $name
          format: $format
          detailLevel: $detailLevel
          customInstructions: $customInstructions
        }
      ) {
        ...LlmOutputPref
      }
    }
  `,
  [llmOutputPreferencesFragment],
);

export const updateChatPreferenceMutation = graphql(
  `
    mutation UpdateChatPreference(
      $tenantId: uuid!
      $id: uuid!
      $name: String
      $format: String!
      $detailLevel: String!
      $customInstructions: String
    ) {
      updateTenantUserLlmOutputPreferencesByPk(
        pkColumns: { tenantId: $tenantId, id: $id }
        _set: {
          name: $name
          format: $format
          detailLevel: $detailLevel
          customInstructions: $customInstructions
        }
      ) {
        ...LlmOutputPref
      }
    }
  `,
  [llmOutputPreferencesFragment],
);

export const deleteChatPreferenceMutation = graphql(`
  mutation DeleteChatPreference($tenantId: uuid!, $id: uuid!) {
    deleteTenantUserLlmOutputPreferencesByPk(tenantId: $tenantId, id: $id) {
      __typename
      id
      tenantId
    }
  }
`);
